import { render, staticRenderFns } from "./BoxHead.vue?vue&type=template&id=3eeb71df&scoped=true&"
import script from "./BoxHead.vue?vue&type=script&lang=js&"
export * from "./BoxHead.vue?vue&type=script&lang=js&"
import style0 from "./BoxHead.vue?vue&type=style&index=0&id=3eeb71df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeb71df",
  null
  
)

export default component.exports